import styled from "styled-components";
import { Button } from "../components/Button/Button";
import { Link } from "react-router-dom";
import { LoginForm } from "../components/Auth/LoginForm";

export const Login = () => {
	return (
		<StyledComponent>
			<LoginForm />
			<Link to="/registracion">
				<Button type="button" className="regBtn">
					Регистрация
				</Button>
			</Link>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	width: 200px;
	padding: 1rem;
	margin: auto;
	padding-top: 15%;

	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	& form {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	& .regBtn {
		width: 100%;
	}
`;
